// All config. options available here:https://cookieconsent.orestbida.com/reference/configuration-reference.html
const config = {
    disablePageInteraction: true,

    guiOptions: {
        consentModal: {
            layout: 'box inline',
            position: 'middle center',
            equalWeightButtons: true,
        },
        preferencesModal: {
            layout: 'box',
            flipButtons: true,
            equalWeightButtons: true,
        }
    },

    categories: {
        necessary: {
            readOnly: true,
            enabled: true
        },
        statistic: {
            readOnly: false,
            enabled: false,
        },
        functional: {
            readOnly: false,
            enabled: false,
        },
        marketing: {
            readOnly: false,
            enabled: false,
        }
    },

    language: {
        default: gardaseeContext.language,
        translations: {
            de: {
                consentModal: {
                    title: 'Diese Webseite verwendet Cookies &#x1F36A',
                    description: 'Wir setzen Cookies ein, um Ihre digitale Reise bei uns noch köstlicher zu machen. Mit einem Klick auf „Alle akzeptieren“ erlauben Sie uns, Ihren Aufenthalt zu versüßen, Ihr Surf-Erlebnis zu verbessern und maßgeschneiderte Inhalte zu servieren. Wenn Sie mehr darüber erfahren möchten, welche Zutaten wir verwenden oder Ihre Einstellungen ändern möchten, klicken Sie auf ><a href="#privacy-policy" data-cc="show-preferencesModal" class="cc__link">Anpassen</a><.',
                    acceptAllBtn: 'Alle akzeptieren',
                    acceptNecessaryBtn: 'Alle ablehnen',
                    showPreferencesBtn: 'Anpassen',
                    footer: "<a href=\"" + gardaseeContext.privacyLink + "\">Datenschutz</a>\n<a href=\"" + gardaseeContext.imprintLink + "\">Impressum</a>"
                },
                preferencesModal: {
                    title: 'Cookie-Einstellungen',
                    acceptAllBtn: 'Alle akzeptieren',
                    acceptNecessaryBtn: "Alle ablehnen",
                    savePreferencesBtn: 'Auswahl erlauben',
                    closeIconLabel: 'Schließen',

                    sections: [
                        {
                            title: 'Diese Webseite verwendet Cookies',
                            description: 'Hier können Sie die Dienste, die wir auf dieser Website nutzen möchten, anpassen. Wir würden Ihre Daten gerne zu folgenden Zwecken verwenden (um mehr zu erfahren, lesen Sie bitte unsere <a href="' + gardaseeContext.privacyLink + '" class="cc_link_underlined">Datenschutzerklärung</a>):',
                        }, {
                            title: 'Notwendig',
                            description: 'Diese Cookies sind für das reibungslose Funktionieren der Website unerlässlich und können nicht deaktiviert werden.',
                            linkedCategory: 'necessary'
                        }, {
                            title: 'Statistik',
                            description: 'Diese Dienste werten das Nutzungsverhalten anonymisiert aus, um uns zu erlauben die Seite zu optimieren. Sie verarbeiten persönliche Informationen, um Ihnen personalisierte oder interessenbezogene Werbung zu zeigen.',
                            linkedCategory: 'statistic'
                        }, {
                            title: 'Funktional',
                            description: 'Wir verwenden diese Cookies, um die Funktionalität zu verbessern und die Personalisierung zu ermöglichen.',
                            linkedCategory: 'functional'
                        }, {
                            title: 'Marketing',
                            description: 'Diese Cookies werden für Marketingzwecke genutzt.',
                            linkedCategory: 'marketing'
                        }
                    ]
                }
            },
            it: {
                consentModal: {
                    title: 'Questo sito web utilizza i cookie &#x1F36A',
                    description: 'Utilizziamo i cookie per rendere il vostro viaggio digitale con noi ancora più piacevole.  Facendo clic su "Accetta tutti", ci permettete di addolcire il vostro soggiorno, migliorare la vostra esperienza di navigazione e proporre contenuti personalizzati. Se volete maggiori informazioni o per modificare le vostre impostazioni, cliccate su ><a href="#privacy-policy" data-cc="show-preferencesModal" class="cc__link">Personalizzare</a><.',
                    acceptAllBtn: 'Accettare tutti',
                    acceptNecessaryBtn: 'Rifiutare tutti',
                    showPreferencesBtn: 'Personalizzare',
                    footer: "<a href=\"" + gardaseeContext.privacyLink + "\">Privacy</a>\n<a href=\"" + gardaseeContext.imprintLink + "\">Impressum</a>"
                },
                preferencesModal: {
                    title: 'Impostazioni dei cookie',
                    acceptAllBtn: 'Accettare tutti',
                    acceptNecessaryBtn: "Rifiutare tutti",
                    savePreferencesBtn: 'Accettare selezionato',
                    closeIconLabel: 'Chiudi',

                    sections: [
                        {
                            title: 'Questo sito web utilizza i cookie',
                            description: 'Qui è possibile personalizzare i servizi che si desidera utilizzare per questo sito web. Vorremmo utilizzare i vostri dati per i seguenti scopi (per saperne di più, leggete la nostra <a href="' + gardaseeContext.privacyLink + '" class="cc_link_underlined">politica sulla privacy</a>):'
                        }, {
                            title: 'Necessario',
                            description: 'Questi cookie sono essenziali per il corretto funzionamento del sito e non possono essere disattivati.',
                            linkedCategory: 'necessary'
                        }, {
                            title: 'Statistica',
                            description: 'Questi servizi valutano il comportamento di utilizzo in modo anonimo per consentirci di ottimizzare il sito. Elaborano le informazioni personali per mostrarvi pubblicità personalizzata o basata sugli interessi.',
                            linkedCategory: 'statistic'
                        }, {
                            title: 'Funzionale',
                            description: 'Utilizziamo questi cookie per migliorare la funzionalità e consentire la personalizzazione.',
                            linkedCategory: 'functional'
                        }, {
                            title: 'Marketing',
                            description: 'Questi cookie sono utilizzati per scopi di marketing.',
                            linkedCategory: 'marketing'
                        }
                    ]
                }
            },
            en: {
                consentModal: {
                    title: 'This website uses cookies  &#x1F36A',
                    description: 'We use cookies to make your digital journey with us even more delicious. By clicking ‘Accept all’, you allow us to sweeten your stay, improve your browsing experience and serve customised content. If you want to learn more about what ingredients we use or change your preferences, click on ><a href="#privacy-policy" data-cc="show-preferencesModal" class="cc__link">Manage preferences</a><.',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    showPreferencesBtn: 'Manage preferences',
                    footer: "<a href=\"" + gardaseeContext.privacyLink + "\">Data protection</a>\n<a href=\"" + gardaseeContext.imprintLink + "\">Imprint</a>"
                },
                preferencesModal: {
                    title: 'Cookie settings',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Accept selection',
                    closeIconLabel: 'Close',
                    sections: [
                        {
                            title: 'This website uses cookies',
                            description: 'Here you can customise the services we would like to use on this website. We would like to use your data for the following purposes (to find out more, please read our <a href="' + gardaseeContext.privacyLink + '" class="cc_link_underlined">privacy policy</a>):'
                        },
                        {
                            title: 'Necessary',
                            description: 'These cookies are essential for the proper functioning of the website and cannot be deactivated.',
                            linkedCategory: 'necessary'
                        }, {
                            title: 'Statistics',
                            description: 'These services evaluate usage behaviour anonymously to allow us to optimise the site. They process personal information in order to show you personalised or interest-based advertising.',
                            linkedCategory: 'statistic'
                        }, {
                            title: 'Functional',
                            description: 'We use these cookies to improve functionality and enable personalisation.',
                            linkedCategory: 'functional'
                        }, {
                            title: 'Marketing',
                            description: 'These cookies are used for marketing purposes.',
                            linkedCategory: 'marketing'
                        }
                    ]
                }
            }
        }
    },

    onConsent: ({ cookie }) => {
        setConsentMode(cookie.categories, cookie.categories);
    },

    onChange: ({ cookie, changedCategories, changedServices }) => {
        setConsentMode(cookie.categories, changedCategories);
    },
};

CookieConsent.run(config);

const consentCatNecessary = 'necessary';
const consentCatFunctional = 'functional';
const consentCatStatistic = 'statistic';
const consentCatMarketing = 'marketing';

const consentCategoriesAll = [
    consentCatNecessary,
    consentCatFunctional,
    consentCatStatistic,
    consentCatMarketing
];

setConsentMode(consentCategoriesAll, consentCategoriesAll);

function setConsentMode(categories, changedCategories) {

    let isDeniedGranted;

    for (let i in changedCategories) {

        if (categories.includes(changedCategories[i])) {
            isDeniedGranted = "granted";
        } else {
            //isDeniedGranted = "denied";
            isDeniedGranted = "granted";
        }

        if (changedCategories[i] === consentCatFunctional) {
            gtag('consent', 'update', {
                functionality_storage: isDeniedGranted,
                personalization_storage: isDeniedGranted,
            });
        }

        if (changedCategories[i] === consentCatStatistic) {
            gtag('consent', 'update', {
                analytics_storage: isDeniedGranted,
            });
        }

        if (changedCategories[i] === consentCatMarketing) {
            gtag('consent', 'update', {
                ad_storage: isDeniedGranted,
                ad_user_data: isDeniedGranted,
                ad_personalization: isDeniedGranted,
            });
        }
    }
}
